import React, { useState, useEffect } from "react";
import { Select, Radio, Input, Button, Tag, Tabs, List, Form } from "antd";
const { TabPane } = Tabs;
const timeOptions = [
  "Not setting a time",
  "08:00",
  "10:00",
  "12:00",
  "14:00",
  "16:00",
  "18:00",
];

const normalizeFromBackend = (time) =>
  time === null ? "Not setting a time" : time;

const normalizeToBackend = (time) =>
  time === "Not setting a time" ? null : time;

const responsibleOptions = [
  { label: "PickUp", value: "pick_up" },
  { label: "DropOff", value: "drop_off" },
];
const weekDayGroupsStatic = {
  1: {
    parent1: [
      { label: "Monday, Tuesday", value: "Monday Tuesday" },
      { label: "Friday, Saturday, Sunday", value: "Friday Saturday Sunday" },
    ],
    parent2: [{ label: "Wednesday, Thursday", value: "Wednesday Thursday" }],
  },
  2: {
    parent2: [
      { label: "Monday, Tuesday", value: "Monday Tuesday" },
      { label: "Friday, Saturday, Sunday", value: "Friday Saturday Sunday" },
    ],
    parent1: [{ label: "Wednesday, Thursday", value: "Wednesday Thursday" }],
  },
};

const defaultTimes = {
  pick_up: "08:00",
  drop_off: "16:00",
};

const TwoTwoThreeRotation = (props) => {
  const {
    parentId,
    activeComboId,
    activeChildId,
    parentCombinationsV2,
    parentCombinations,
    index,
    modified,
    sameScheduleForAll,
  } = props;

  let parentCombo;
  if (!sameScheduleForAll) {
    parentCombo = parentCombinationsV2.find(
      (combo) =>
        String(combo.coparent_combination_id) === String(activeComboId) &&
        combo.children?.some(
          (child) => String(child.child_id) === String(activeChildId)
        )
    );
  } else {
    parentCombo = parentCombinationsV2.find(
      (combo) => String(combo.coparent_combination_id) === String(activeComboId)
    );
  }

  const buildWeekDayGroups = (parentCombo, activeChildId) => {
    let child;
    if (sameScheduleForAll) {
      child = parentCombo?.children[0];
    } else {
      child = parentCombo.children?.find(
        (c) =>
          !sameScheduleForAll &&
          String(c.child_id || c.id) === String(activeChildId)
      );
    }
    if (!child || !child.week_schedules) return {};

    const weekDayGroups = {};

    child.week_schedules.forEach((week) => {
      // each week has week_number1, week_number2, etc.
      Object.values(week).forEach((weekObj) => {
        const { week_number, parent1_id, parent2_id, segments = [] } = weekObj;

        if (!weekDayGroups[week_number]) {
          weekDayGroups[week_number] = { parent1: [], parent2: [] };
        }

        segments.forEach((seg) => {
          const daysLabel = seg.selected_days.join(", ");
          const daysValue = seg.selected_days.join(" ");

          if (seg.assigned_to === "parent1") {
            weekDayGroups[week_number].parent1.push({
              label: daysLabel,
              value: daysValue,
            });
          }
          if (seg.assigned_to === "parent2") {
            weekDayGroups[week_number].parent2.push({
              label: daysLabel,
              value: daysValue,
            });
          }
        });
      });
    });

    return weekDayGroups;
  };

  const weekDayGroups = buildWeekDayGroups(parentCombo, activeChildId);

  const parent1 = parentCombo?.parent1;
  const parent2 = parentCombo?.parent2;
  const weekSchedules = props.weekSchedules;
  const setWeekSchedules = props.setWeekSchedules;
  const [form] = Form.useForm();

  const [selectedWeek, setSelectedWeek] = useState(index === 0 ? 1 : 2);

  const [showCustom, setShowCustom] = useState(false);
  const [customHour, setCustomHour] = useState();
  const [customMinute, setCustomMinute] = useState();
  const [selectedTime, setSelectedTime] = useState();

  const [parent1Days, setParent1Days] = useState([]);
  const [parent2Days, setParent2Days] = useState([]);
  const [weekSchedulesState, setWeekSchedulesState] = useState(weekSchedules);
  const [parent1TabState, setParent1TabState] = useState({});
  const [parent2TabState, setParent2TabState] = useState({});

  function getInitialTabValueFromV2(dayKey, parentKey) {
    const combo = parentCombinationsV2?.find(
      (c) => String(c.coparent_combination_id || c.id) === String(activeComboId)
    );

    if (!combo) {
      // console.log("No combo found");
      return { responsible: undefined, time: undefined };
    }
    let child;
    if (!sameScheduleForAll) {
      child = combo.children?.find(
        (c) => String(c.child_id || c.id) === String(activeChildId)
      );
    } else {
      child = combo.children[0];
    }
    if (
      !child ||
      !Array.isArray(child.week_schedules) ||
      !child.week_schedules[0]
    ) {
      // console.log("no child or no week_schedules", child);
      return { responsible: undefined, time: undefined };
    }

    // Find the correct week object
    const weekObj = child.week_schedules[0];
    const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
    const weekData = weekObj[weekKey];
    if (!weekData || !Array.isArray(weekData.segments))
      return { responsible: undefined, time: undefined };

    const seg = weekData.segments.find(
      (seg) => seg.assigned_to === parentKey && Array.isArray(seg.selected_days)
    );
    // console.log("Looking for",  dayKey, parentKey , "found:", seg);

    if (!seg) return { responsible: undefined, time: undefined };

    let time = "";
    if (seg.responsible_for === "pick_up") {
      time = normalizeFromBackend(seg.pickup_time);
    } else if (seg.responsible_for === "drop_off") {
      time = normalizeFromBackend(seg.dropoff_time);
    }
    return {
      responsible: seg.responsible_for,
      time,
    };
  }

  // useEffect(() => {
  //   setWeekSchedulesState(weekSchedules);
  // }, [weekSchedules]);

  const handleResponsibleForChange = (val) => {
    form.setFieldsValue({
      time: defaultTimes[val],
    });
  };

  // Correct init: use existing schedules if available, else []
  // Keep only the relevant time field, remove the other one
  function normalizeSegment(seg) {
    const base = {
      selected_days: seg.selected_days,
      assigned_to: seg.assigned_to, // keep whatever you pass in
      responsible_for: seg.responsible_for, // "pick_up" | "drop_off"
    };
    if (seg.responsible_for === "pick_up") {
      return { ...base, pickup_time: normalizeToBackend(seg.pickup_time) };
    }
    return { ...base, dropoff_time: normalizeToBackend(seg.dropoff_time) };
  }

  // Merge `updates` into `existing` without creating a new segment
  // for the same day-group; replace it instead (even if responsible_for changed)
  function mergeWeekSchedules(existing, updates) {
    // Deep-clone to keep it pure
    const merged = JSON.parse(JSON.stringify(existing || []));

    // Optional: if multiple updates target the same day-group in the same week,
    // keep only the last one in `updates`.
    const reducedUpdates = updates.map((u) => {
      const weekKey = Object.keys(u)[0];
      const wk = u[weekKey] || {};
      const byDay = new Map();
      (wk.segments || []).forEach((seg) => {
        const dayKey = (seg.selected_days || []).join(" ");
        byDay.set(dayKey, normalizeSegment(seg)); // last write wins
      });
      return {
        [weekKey]: {
          ...wk,
          segments: Array.from(byDay.values()),
        },
      };
    });

    reducedUpdates.forEach((update) => {
      const weekKey = Object.keys(update)[0]; // "week_number1" | "week_number2" ...
      const updateWeek = update[weekKey];

      // Find or create the week shell in merged
      let wrapper = merged.find((w) => w[weekKey]);
      if (!wrapper) {
        merged.push({ [weekKey]: { ...updateWeek, segments: [] } });
        wrapper = merged[merged.length - 1];
      }

      const targetWeekObj = wrapper[weekKey];
      const targetSegments = Array.isArray(targetWeekObj.segments)
        ? [...targetWeekObj.segments]
        : [];

      (updateWeek.segments || []).forEach((segUpdate) => {
        const dayKey = (segUpdate.selected_days || []).join(" ");

        // 🔑 CRITICAL: remove any existing segment for THIS day-group,
        // regardless of assigned_to or responsible_for
        const filtered = targetSegments.filter(
          (s) => (s.selected_days || []).join(" ") !== dayKey
        );

        // Add the normalized, updated segment
        filtered.push(normalizeSegment(segUpdate));

        // write back
        wrapper[weekKey] = {
          ...targetWeekObj,
          week_number: updateWeek.week_number ?? targetWeekObj.week_number,
          segments: filtered,
        };
      });
    });

    return merged;
  }

  useEffect(() => {
    if (typeof props.setParentCombinationsV2 === "function") {
      props.setParentCombinationsV2((prev) =>
        prev.map((combo) => {
          if (
            String(combo?.id || combo?.coparent_combination_id) !==
            String(props.activeComboId)
          )
            return combo;
          return {
            ...combo,
            children: combo.children.map((child) => {
              try {
                if (
                  sameScheduleForAll &&
                  String(child?.id || child?.child_id) !==
                    String(props.activeChildId)
                ) {
                  const existing = Array.isArray(child.week_schedules)
                    ? child.week_schedules
                    : [];
                  const updates = Array.isArray(weekSchedules)
                    ? weekSchedules
                    : [];

                  // only merge if we actually have updates
                  const merged =
                    updates.length > 0
                      ? mergeWeekSchedules(existing, updates)
                      : existing;
                  return { ...child, week_schedules: merged };
                } else {
                  const updatedWeekSchedules = (child.week_schedules || []).map(
                    (weekObj) => {
                      const weekKey =
                        selectedWeek === 1 ? "week_number1" : "week_number2";
                      if (!weekObj[weekKey]) return weekObj;

                      const updatedWeek = (weekSchedules || []).find(
                        (w) => w.week_number === selectedWeek
                      );
                      if (!updatedWeek) return weekObj;

                      return {
                        ...weekObj,
                        [weekKey]: {
                          ...weekObj[weekKey],
                          ...updatedWeek,
                          segments: updatedWeek.segments,
                        },
                      };
                    }
                  );

                  return {
                    ...child,
                    week_schedules: mergeWeekSchedules(
                      child.week_schedules || [],
                      weekSchedules || []
                    ), // <-- was weekSchedules before
                  };
                }
              } catch (err) {
                console.error("Error while updating child:", child, err);
                return child; // fallback
              }
            }),
          };
        })
      );
    }
    // eslint-disable-next-line
  }, [weekSchedules]);

  useEffect(() => {
    // Find the correct combo and child
    const combo = parentCombinationsV2?.find(
      (c) => String(c.coparent_combination_id || c.id) === String(activeComboId)
    );
    if (!combo) return;
    let child;
    if (sameScheduleForAll) {
      child = parentCombo?.children[0];
    } else {
      child = parentCombo.children?.find(
        (c) =>
          !sameScheduleForAll &&
          String(c.child_id || c.id) === String(activeChildId)
      );
    }

    if (
      !child ||
      !Array.isArray(child.week_schedules) ||
      !child.week_schedules[0]
    )
      return;

    // Find the correct week object
    const weekObj = child.week_schedules[0];
    const weekKey1 = "week_number1";
    const weekKey2 = "week_number2";
    const segments1 = weekObj[weekKey1]?.segments || [];
    const segments2 = weekObj[weekKey2]?.segments || [];

    // Helper to build state from segments
    const buildTabState = (segments, parentKey) => {
      const state = {};
      segments.forEach((seg) => {
        if (seg.assigned_to === parentKey) {
          const dayKey = Array.isArray(seg.selected_days)
            ? seg.selected_days.join(" ")
            : "";
          let time = "";
          if (seg.responsible_for === "pick_up") {
            time =
              seg.pickup_time === null ? "Not setting a time" : seg.pickup_time;
          } else if (seg.responsible_for === "drop_off") {
            time =
              seg.dropoff_time === null
                ? "Not setting a time"
                : seg.dropoff_time;
          }
          state[dayKey] = {
            responsible: seg.responsible_for,
            time: time,
          };
        }
      });
      return state;
    };

    // Collect all day groups for each parent
    const getAllDayGroups = (segments, parentKey) =>
      segments
        .filter(
          (seg) =>
            seg.assigned_to === parentKey && Array.isArray(seg.selected_days)
        )
        .map((seg) => seg.selected_days.join(" "));

    // Set state for week 1 or 2 depending on selectedWeek
    if (selectedWeek === 1) {
      setParent1TabState(buildTabState(segments1, "parent1"));
      setParent2TabState(buildTabState(segments1, "parent2"));
      setParent1Days(getAllDayGroups(segments1, "parent1"));
      setParent2Days(getAllDayGroups(segments1, "parent2"));
    } else {
      setParent1TabState(buildTabState(segments2, "parent1"));
      setParent2TabState(buildTabState(segments2, "parent2"));
      setParent1Days(getAllDayGroups(segments2, "parent1"));
      setParent2Days(getAllDayGroups(segments2, "parent2"));
    }
  }, [activeComboId, activeChildId]);

  // Handle add segment
  const handleAddSegment = (values) => {
    setWeekSchedules((prev) => {
      // Find the week object (with week_number1/week_number2)
      let found = false;
      const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
      const newSegment = {
        selected_days: values.segment.split(" "),
        assigned_to:
          values.responsibleFor === "pick_up" ? "parent1" : "parent2",
        responsible_for: values.responsibleFor,
        ...(values.responsibleFor === "pick_up"
          ? {
              pickup_time:
                values.time === "Not setting a time" ? null : values.time,
            }
          : {
              dropoff_time:
                values.time === "Not setting a time" ? null : values.time,
            }),
      };
      const updated = prev.map((weekObj) => {
        if (weekObj[weekKey]) {
          found = true;
          return {
            ...weekObj,
            [weekKey]: {
              ...weekObj[weekKey],
              segments: [...(weekObj[weekKey].segments || []), newSegment],
            },
          };
        }
        return weekObj;
      });
      if (!found) {
        // Add new week object if not found
        return [
          ...prev,
          {
            [weekKey]: {
              week_number: selectedWeek,
              [`parent${selectedWeek}_id`]:
                selectedWeek === 1 ? parent1?.user_id : parent2?.user_id,
              segments: [newSegment],
            },
          },
        ];
      }
      return updated;
    });
    form.resetFields();
    form.setFieldsValue({
      week: selectedWeek,
    });
    setSelectedTime(null);
  };

  const saveSegments = ({ parent, days, responsible, time }) => {
    const safeDays = Array.isArray(days) ? days : days ? [days] : [];
    setWeekSchedules((prev) => {
      const weekKey = selectedWeek === 1 ? "week_number1" : "week_number2";
      let found = false;
      const updated = prev.map((weekObj) => {
        if (weekObj[weekKey]) {
          found = true;
          // Remove any existing segment for this parent and this exact day group
          let updatedSegments = (weekObj[weekKey].segments || []).filter(
            (seg) =>
              !safeDays.some(
                (dayGroup) =>
                  seg.assigned_to === parent &&
                  Array.isArray(seg.selected_days) &&
                  seg.selected_days.join(" ") === dayGroup
              )
          );
          // Add new/updated segments
          safeDays.forEach((dayGroup) => {
            if (responsible && time) {
              updatedSegments.push({
                selected_days: dayGroup.split(" "),
                assigned_to: parent,
                responsible_for: responsible,
                ...(responsible === "pick_up"
                  ? { pickup_time: normalizeToBackend(time) }
                  : { dropoff_time: normalizeToBackend(time) }),
              });
            }
          });
          return {
            ...weekObj,
            [weekKey]: {
              ...weekObj[weekKey],
              segments: updatedSegments,
            },
          };
        }
        return weekObj;
      });
      if (!found) {
        // Add new week object if not found
        return [
          ...prev,
          {
            [weekKey]: {
              week_number: selectedWeek,
              [`parent${selectedWeek}_id`]:
                selectedWeek === 1 ? parent1?.user_id : parent2?.user_id,
              segments: safeDays.map((dayGroup) => ({
                selected_days: dayGroup.split(" "),
                assigned_to: parent,
                responsible_for: responsible,
                ...(responsible === "pick_up"
                  ? { pickup_time: normalizeToBackend(time) }
                  : { dropoff_time: normalizeToBackend(time) }),
              })),
            },
          },
        ];
      }
      return updated;
    });
  };

  const handleParent1TabChange = (key, field, value) => {
    setParent1TabState((prev) => {
      const newState = {
        ...prev,
        [key]: { ...prev[key], [field]: value },
      };
      if (newState[key].responsible && newState[key].time) {
        saveSegments({
          parent: "parent1",
          days: [key],
          responsible: newState[key].responsible,
          time: newState[key].time,
        });
      }
      return newState;
    });
  };

  useEffect(() => {
    setSelectedTime(form.getFieldValue("time"));
  }, []);

  const renderTimeOptions = (selectedTime, onSelect) => {
    const normalizedSelected =
      selectedTime &&
      (selectedTime === "Not setting a time"
        ? "Not setting a time"
        : selectedTime);

    const isCustomSelected =
      normalizedSelected && !timeOptions.includes(normalizedSelected);

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {timeOptions.map((option) => (
          <Tag.CheckableTag
            key={option}
            checked={normalizedSelected === option}
            onChange={() => onSelect(option)}
            style={{
              borderRadius: 8,
              padding: "4px 12px",
              backgroundColor:
                normalizedSelected === option ? "#f3e8ff" : "#f6f6f6",
              color: normalizedSelected === option ? "#9A4FE0" : "#000",
            }}
          >
            {option}
          </Tag.CheckableTag>
        ))}

        {/* Always show a tag if selectedTime is a custom value */}
        {isCustomSelected && (
          <Tag.CheckableTag
            key={normalizedSelected}
            checked
            onChange={() => onSelect(normalizedSelected)}
            style={{
              borderRadius: 8,
              padding: "4px 12px",
              backgroundColor: "#f3e8ff",
              color: "#9A4FE0",
            }}
          >
            {normalizedSelected}
          </Tag.CheckableTag>
        )}

        <Button
          type={showCustom ? "primary" : "dashed"}
          onClick={() => setShowCustom(!showCustom)}
        >
          Customize...
        </Button>

        {showCustom && (
          <div
            style={{
              marginTop: 16,
              display: "flex",
              gap: 8,
              alignItems: "center",
            }}
          >
            <Select
              placeholder="HH"
              value={customHour}
              onChange={setCustomHour}
              style={{ width: 80 }}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <Select.Option key={i} value={i}>
                  {String(i).padStart(2, "0")}
                </Select.Option>
              ))}
            </Select>
            <span>:</span>
            <Select
              placeholder="MM"
              value={customMinute}
              onChange={setCustomMinute}
              style={{ width: 80 }}
            >
              {[0, 15, 30, 45].map((i) => (
                <Select.Option key={i} value={i}>
                  {String(i).padStart(2, "0")}
                </Select.Option>
              ))}
            </Select>
            <Button
              type="primary"
              disabled={customHour === undefined || customMinute === undefined}
              onClick={() => {
                const customTime = `${String(customHour).padStart(
                  2,
                  "0"
                )}:${String(customMinute).padStart(2, "0")}`;
                setSelectedTime(customTime);
                form.setFieldsValue({ time: customTime });
                setShowCustom(false);
                onSelect(customTime); // ✅ immediately trigger
              }}
            >
              Save
            </Button>
          </div>
        )}
      </div>
    );
  };

  const availableWeekDayGroups =
    Object.keys(weekDayGroups).length < 2 ? weekDayGroupsStatic : weekDayGroups;

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changed, all) => {
          if (changed.week) setSelectedWeek(changed.week);
          if (changed.responsibleFor)
            handleResponsibleForChange(changed.responsibleFor);
        }}
        onFinish={handleAddSegment}
      >
        <Form.Item required label={`${parent1?.name || "Parent 1"} Week ${selectedWeek} Days`}>
          
          <Tabs
            activeKey={parent1Days.length > 0 ? parent1Days[0] : undefined}
            onChange={(key) => {
              setParent1Days([key]);
              setParent1TabState((prev) => {
                if (prev[key]) return prev;
                const initial = getInitialTabValueFromV2(key, "parent1");
                return {
                  ...prev,
                  [key]: initial,
                };
              });
            }}
            type="card"
          >
            {weekDayGroupsStatic[selectedWeek].parent1.map((option) => (
              <TabPane tab={option.label} key={option.value}>
                <Form.Item label="Responsible For" required>
                  <Radio.Group
                    options={responsibleOptions}
                    value={parent1TabState[option.value]?.responsible}
                    onChange={(e) =>
                      handleParent1TabChange(
                        option.value,
                        "responsible",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
                {parent1TabState[option.value]?.responsible && (
                  <Form.Item
                    label={
                      parent1TabState[option.value]?.responsible === "pick_up"
                        ? `${parent1?.name || "Parent 1"} pick up time`
                        : `${parent2?.name || "Parent 2"} drop off time`
                    }
                    required
                  >
                    {renderTimeOptions(
                      parent1TabState[option.value]?.time,
                      (val) => handleParent1TabChange(option.value, "time", val)
                    )}
                  </Form.Item>
                )}
              </TabPane>
            ))}
          </Tabs>
        </Form.Item>
        <Form.Item
          required
          label={`${parent2?.name || "Parent 2"} Week ${selectedWeek} Days`}
        >
          <Tabs
            activeKey={parent2Days.length > 0 ? parent2Days[0] : undefined}
            onChange={(key) => {
              setParent2Days([key]);
              setParent2TabState((prev) => {
                if (prev[key]) return prev;
                const initial = getInitialTabValueFromV2(key, "parent2");
                return {
                  ...prev,
                  [key]: initial,
                };
              });
            }}
            type="card"
          >
            {weekDayGroupsStatic[selectedWeek].parent2.map((option) => (
              <TabPane tab={option.label} key={option.value}>
                <Form.Item label="Responsible For" required>
                  <Radio.Group
                    options={responsibleOptions}
                    value={parent2TabState[option.value]?.responsible}
                    onChange={(e) => {
                      setParent2TabState((prev) => {
                        const newState = {
                          ...prev,
                          [option.value]: {
                            ...prev[option.value],
                            responsible: e.target.value,
                          },
                        };
                        if (
                          newState[option.value].responsible &&
                          newState[option.value].time
                        ) {
                          saveSegments({
                            parent: "parent2",
                            days: [option.value],
                            responsible: newState[option.value].responsible,
                            time: newState[option.value].time,
                          });
                        }
                        return newState;
                      });
                    }}
                  />
                </Form.Item>
                {parent2TabState[option.value]?.responsible && (
                  <Form.Item
                    label={
                      parent2TabState[option.value]?.responsible === "pick_up"
                        ? `${parent2?.name || "Parent 2"} pick up time`
                        : `${parent1?.name || "Parent 1"} drop off time`
                    }
                    required
                  >
                    {renderTimeOptions(
                      parent2TabState[option.value]?.time,
                      (val) =>
                        setParent2TabState((prev) => {
                          const newState = {
                            ...prev,
                            [option.value]: {
                              ...prev[option.value],
                              time: val,
                            },
                          };
                          if (
                            newState[option.value].responsible &&
                            newState[option.value].time
                          ) {
                            saveSegments({
                              parent: "parent2",
                              days: [option.value],
                              responsible: newState[option.value].responsible,
                              time: val,
                            });
                          }
                          return newState;
                        })
                    )}
                  </Form.Item>
                )}
              </TabPane>
            ))}
          </Tabs>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TwoTwoThreeRotation;
